import MenuLG from './MenuLG';

export default class MenuMD extends MenuLG {
}